<div class="form-row row">
  <div class="col">
    <div class="d-flex mb-2">
      <span class="flex-grow-1 my-auto">
        {{title}}
      </span>
      <span class="e-icons icon-add e-icon-big my-auto" (click)="this.grid.addRecord()"
        title="{{ 'i18n.domain.export-configuration.configurations.overview.add-button-tooltip' | translate }}">
      </span>
    </div>
  </div>

</div>
<div class="form-row row">
  <div class="col">
    <ejs-grid #grid class="grid-no-filter" width="100%" rowHeight="38" [dataSource]="data" [allowSorting]="true"
      [allowFiltering]="true" [filterSettings]="filterSettings" [allowPaging]="false" [editSettings]="editSettings"
      (commandClick)="commandClicked($event)" (actionBegin)="actionBegin($event)"
      (actionComplete)="actionComplete($event)">
      <e-columns>
        <e-column field="filterBrand" [isPrimaryKey]="true"
          headerText="{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.brand' | translate}}"
          clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="filterSubBrand" [isPrimaryKey]="true"
          headerText="{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.brand-sub' | translate}}"
          clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column headerText="" [commands]="gridCommands"></e-column>
      </e-columns>
      <ng-template #editSettingsTemplate let-data>
        <form [formGroup]="gridEditForm">
          <div class="form-row row">
            <div class="form-group col-12">
              <label for="filterBrand"
                class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.brand'
                | translate}}</label>
              <ejs-dropdownlist id="filterBrand" [dataSource]="brands" (change)="brandChange($event)"
                [showClearButton]="true" formControlName="filterBrand">
              </ejs-dropdownlist>
            </div>
          </div>
          <div class="form-row row">
            <div class="form-group col-12">
              <label for="filterSubBrand"
                class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.brand-sub'
                | translate}}</label>
              <ejs-dropdownlist id="filterSubBrand" [dataSource]="subBrands" [showClearButton]="true"
                formControlName="filterSubBrand">
              </ejs-dropdownlist>
            </div>
          </div>
        </form>
      </ng-template>
    </ejs-grid>
  </div>
</div>